import { WhatsNewCardIdentity } from './WhatsNewCardIdentity';

import AddFlairWithExpressions from '../../components/cards/AddFlairWithExpressions';
import BoldCalendarColorsCard from '../../components/cards/BoldCalendarColorsCard';
import DarkModeCard from '../../components/cards/DarkModeCard';
import SmartSearchCard from '../../components/cards/SmartSearchCard';
import FilesHubCard from '../../components/cards/FilesHubCard';
import ScheduleAtGlanceCard from '../../components/cards/ScheduleAtGlanceCard';
import GroupsHubPendingMembershipCard from '../../components/cards/GroupsHubPendingMembershipCard';
import GroupsHubRestoreCard from '../../components/cards/GroupsHubRestoreCard';
import AddCloudCacheAccountCard from '../../components/cards/AddCloudCacheAccountCard';
import NonPremiumDomainConnectUpsellExp from '../../components/cards/NonPremiumDomainConnectUpsellExp';
import NonPremiumTravelUpsellExp from '../../components/cards/NonPremiumTravelUpsellExp';
import PremiumDomainConnectExp from '../../components/cards/PremiumDomainConnectExp';
import PremiumTravelExp from '../../components/cards/PremiumTravelExp';
import TimePanelCard from '../../components/cards/TimePanelCard';
import PauseInboxCard from '../../components/cards/PauseInboxCard';
import PasteLinksCard from '../../components/cards/PasteLinksCard';
import PersonalBookingsCard from '../../components/cards/PersonalBookingsCard';
import StickyNotesCard from '../../components/cards/StickyNotesCard';
import TeamSnapCard from '../../components/cards/TeamSnapCard';
import SchoolCalendarsCard from '../../components/cards/SchoolCalendarsCard';
import InlineTranslationCard from '../../components/cards/InlineTranslationCard';
import AddPersonalCalendarCard from '../../components/cards/AddPersonalCalendarCard';
import { proofingConsumerCard, proofingBusinessCard } from '../../components/cards/ProofingCards';
import OutlookSpacesCard from '../../components/cards/OutlookSpacesCard';
import Covid19TrackerCard from '../../components/cards/Covid19TrackerCard';

// Cards will be ordered by feature type and creation time. Cards for Premium feature will always
// show on the top, and then by creation time in descending order.
export const WhatsNewCardPropertiesMap = {
    [WhatsNewCardIdentity.AddCloudCacheAccount]: AddCloudCacheAccountCard,
    [WhatsNewCardIdentity.AddFlairWithExpressions]: AddFlairWithExpressions,
    [WhatsNewCardIdentity.DarkMode]: DarkModeCard,
    [WhatsNewCardIdentity.SmartSearch]: SmartSearchCard,
    [WhatsNewCardIdentity.FilesHub]: FilesHubCard,
    [WhatsNewCardIdentity.ScheduleAtGlance]: ScheduleAtGlanceCard,
    [WhatsNewCardIdentity.BoldCalendarColors]: BoldCalendarColorsCard,
    [WhatsNewCardIdentity.GroupsHubPendingMembership]: GroupsHubPendingMembershipCard,
    [WhatsNewCardIdentity.GroupsHubRestore]: GroupsHubRestoreCard,
    [WhatsNewCardIdentity.NonPremiumDomainConnectUpsellExp]: NonPremiumDomainConnectUpsellExp,
    [WhatsNewCardIdentity.NonPremiumTravelUpsellExp]: NonPremiumTravelUpsellExp,
    [WhatsNewCardIdentity.PremiumDomainConnectExp]: PremiumDomainConnectExp,
    [WhatsNewCardIdentity.PremiumTravelExp]: PremiumTravelExp,
    [WhatsNewCardIdentity.TimePanel]: TimePanelCard,
    [WhatsNewCardIdentity.PauseInbox]: PauseInboxCard,
    [WhatsNewCardIdentity.PasteLinks]: PasteLinksCard,
    [WhatsNewCardIdentity.PersonalBookings]: PersonalBookingsCard,
    [WhatsNewCardIdentity.StickyNotes]: StickyNotesCard,
    [WhatsNewCardIdentity.TeamSnap]: TeamSnapCard,
    [WhatsNewCardIdentity.SchoolCalendars]: SchoolCalendarsCard,
    [WhatsNewCardIdentity.InlineTranslation]: InlineTranslationCard,
    [WhatsNewCardIdentity.AddPersonalCalendar]: AddPersonalCalendarCard,
    [WhatsNewCardIdentity.ProofingConsumerFree]: proofingConsumerCard,
    [WhatsNewCardIdentity.ProofingBusiness]: proofingBusinessCard,
    [WhatsNewCardIdentity.OutlookSpaces]: OutlookSpacesCard,
    [WhatsNewCardIdentity.COVID19]: Covid19TrackerCard,
};
